// extracted by mini-css-extract-plugin
export default {"colors":"iDCpC8EtPdGtJWRLl4sW","wrapper":"HqmoJR_I3iu18GcRcuKQ","button":"lQuTOHtUPofvpvbLHi2C","active":"Eb8GQZlM1QDMlWioXHyp","button__icon":"EWPDCDSIv4m8QDWClBgJ"};